import React from 'react';
import { useWishlist } from '../context/WishlistContext';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import { useHome } from '../context/HomeContext';
import Breadcrumb from '../components/Breadcrumb';
import ShippingInfo from '../components/ShippingInfo';
import Footer from '../components/Footer';
import { API_CONFIG } from '../config/apiConfig';
import ProductCard from '../components/ProductCard';

const WishlistPage = () => {
  const wishlist = useWishlist();
  const cart = useCart();
  const wishlistItems = wishlist.wishlist;
  const { homeData } = useHome();
  const newProducts = homeData?.topProducts || [];

  return (
    <>
      <Header />

      <main className="main__content_wrapper">
        <Breadcrumb title="Wishlist" items={[{ label: 'Home', href: '/' }, { label: 'Wishlist' }]} />

        <section className="cart__section section--padding">
          <div className="container">
            <div className="cart__section--inner">
              <form action="#">
                <h2 className="cart__title mb-40">Wishlist</h2>
                <div className="cart__table">
                  <table className="cart__table--inner">
                    <thead className="cart__table--header">
                      <tr className="cart__table--header__items">
                        <th className="cart__table--header__list">Product</th>
                        <th className="cart__table--header__list">Price</th>
                        <th className="cart__table--header__list text-center">STOCK STATUS</th>
                        <th className="cart__table--header__list text-right">ADD TO CART</th>
                      </tr>
                    </thead>
                    <tbody className="cart__table--body">
                      {wishlistItems.length === 0 ? (
                        <tr><td colSpan="4" style={{ textAlign: 'center', padding: '32px' }}>Your wishlist is empty.</td></tr>
                      ) : (
                        wishlistItems.map((item) => (
                          <tr key={item.id} className="cart__table--body__items">
                            <td className="cart__table--body__list">
                              <div className="cart__product d-flex align-items-center">
                                <button className="cart__remove--btn" aria-label="Remove from wishlist" type="button" onClick={() => wishlist.removeFromWishlist(item.id)}>
                                  <svg fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="16px" height="16px">
                                    <path d="M 4.7070312 3.2929688 L 3.2929688 4.7070312 L 10.585938 12 L 3.2929688 19.292969 L 4.7070312 20.707031 L 12 13.414062 L 19.292969 20.707031 L 20.707031 19.292969 L 13.414062 12 L 20.707031 4.7070312 L 19.292969 3.2929688 L 12 10.585938 L 4.7070312 3.2929688 z"/>
                                  </svg>
                                </button>
                                <div className="cart__thumbnail">
                                  <Link to={`/product/${item.id}`}>
                                    <img className="border-radius-5" src={item.cover ? (item.cover.startsWith('http') ? item.cover : `${API_CONFIG.IMAGE_URL}${item.cover}`) : '/assets/img/product/default.png'} alt="cart-product" />
                                  </Link>
                                </div>
                                <div className="cart__content">
                                  <h3 className="cart__content--title h4">
                                    <Link to={`/product/${item.id}`}>{item.name}</Link>
                                  </h3>
                                  {/* Optionally show more product info here */}
                                </div>
                              </div>
                            </td>
                            <td className="cart__table--body__list">
                              <span className="cart__price">${(item.price || item.sell_price || 0).toFixed(2)}</span>
                            </td>
                            <td className="cart__table--body__list text-center">
                              <span className="in__stock text__secondary">In stock</span>
                            </td>
                            <td className="cart__table--body__list text-right">
                              <button className="wishlist__cart--btn btn" onClick={() => cart.addToCart(item)}>Add To Cart</button>
                            </td>
                          </tr>
                        ))
                      )}
                    </tbody>
                  </table>
                  <div className="continue__shopping d-flex justify-content-between">
                    <Link className="continue__shopping--link" to="/">Continue shopping</Link>
                    <Link className="continue__shopping--clear" to="/shop">View All Products</Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>

        <section className="product__section product__section--style3 section--padding pt-0">
          <div className="container">
            <div className="section__heading3 mb-40">
              <h2 className="section__heading3--maintitle">New Products</h2>
            </div>
            <div className="product__section--inner product3__section--inner__padding product__section--style3__inner">
              <div className="row row-cols-xl-4 row-cols-lg-3 row-cols-md-2 row-cols-sm-2 row-cols-1 mb--n28" style={{ justifyContent: 'center' }}>
                {newProducts && newProducts.length > 0 && newProducts.slice(0, 4).map((product) => (
                  <div key={product.id || Math.random()} className="col mb-28 d-flex justify-content-center">
                    <ProductCard product={product} />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        {/* <div className="brand__logo--section section--padding pt-0">
          <div className="container">
            <div className="row row-cols-1">
              <div className="col">
                <div className="brand__logo--section__inner d-flex justify-content-between align-items-center">
                  {[1, 2, 3, 4, 5].map((num) => (
                    <div key={num} className="brand__logo--items">
                      <img className="brand__logo--items__thumbnail--img display-block" src={`/assets/img/logo/brand-logo${num}.png`} alt="brand img" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div> */}

        <ShippingInfo />
      </main>

      <Footer />
    </>
  );
};

export default WishlistPage;
